import { mutator } from 'satcheljs';
import { onSigningCertificateChanged } from '../actions/internalActions';
import store from '../store/store';

/**
 * Mutator that sets the property signingCertificateId and signingCertificateSubject
 */
export default mutator(onSigningCertificateChanged, actionMessage => {
    const smimeOptionsStore = store();
    smimeOptionsStore.signingCertificateId = actionMessage.signingCertificateId;
    smimeOptionsStore.signingCertificateSubject = actionMessage.signingCertificateSubject;
});
